/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ExamEditForm model module.
   * @module textbook/model/ExamEditForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ExamEditForm</code>.
   * @alias module:textbook/model/ExamEditForm
   * @class
   * @param id {Integer} paperId
   */
  var exports = function(id) {
    var _this = this;

    _this['id'] = id;



  };

  /**
   * Constructs a <code>ExamEditForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/ExamEditForm} obj Optional instance to populate.
   * @return {module:textbook/model/ExamEditForm} The populated <code>ExamEditForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'triesLimit')) {
        obj['triesLimit'] = ApiClient.convertToType(data['triesLimit'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'timeLimit')) {
        obj['timeLimit'] = ApiClient.convertToType(data['timeLimit'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * paperId
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 考试说明
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 考试次数限制, NULL 为不限制
   * @member {Integer} triesLimit
   */
  exports.prototype['triesLimit'] = undefined;
  /**
   * 时间限制,单位秒 NULL 为不限制
   * @member {Integer} timeLimit
   */
  exports.prototype['timeLimit'] = undefined;



  export default exports;
;


